import React from "react";

function getStarLevelSpan(star_level){
    return (
        <span className="starstop-s">
              <span className={"starlight stars"+star_level}></span>
        </span>
    )
}

// Helper function to get rating display (works for both public and private)
function getRatingDisplay(subject, isPrivate = false) {
    if (isPrivate) {
        // For private search, use user_rating from user_collection
        if (subject.user_collection && subject.user_collection.length > 0) {
            let user_rating = subject.user_collection[0].user_rating;
            if (user_rating != null) {
                let rating_round = (Math.round(user_rating*10)/10).toFixed(1);
                let star_level = Math.round(user_rating);
                return (
                    <>
                        {getStarLevelSpan(star_level)}
                        <small className="fade"> {rating_round} </small>
                    </>
                );
            }
        }
        return null;
    } else {
        // For public search, use public rating
        let has_rating = subject.rating != null ? true: false
        let rating_round = (Math.round(subject.rating*10)/10).toFixed(1)
        let star_level = Math.round(subject.rating)
        let lt_10 = subject.votes < 10 ? true : false
        
        if (!has_rating) return null;
        
        return (
            <>
                {!lt_10 && getStarLevelSpan(star_level)}
                {!lt_10 && <small className="fade"> {rating_round} </small>}
                {lt_10 ? <span className="tip_j">(少于10人评分)</span> :
                    <span className="tip_j">{'('+subject.votes+'人评分)'}</span>}
            </>
        );
    }
}

// Helper function to get date display
function getDateDisplay(subject, isPrivate = false) {
    if (isPrivate) {
        // For private search, show collection date
        if (subject.user_collection && subject.user_collection.length > 0) {
            let collect_date = subject.user_collection[0].collect_date;
            if (collect_date) {
                let displayDate = new Date(collect_date.split('-'));
                return <span className="tip_j">{displayDate.toLocaleDateString("zh-CN")}</span>;
            }
        }
        return null;
    } else {
        // For public search, show release date
        let displayDate = subject.release_date == null ? null : new Date(subject.release_date.split('-'));
        return displayDate ? <span className="tip_j">{displayDate.toLocaleDateString("zh-CN")}</span> : null;
    }
}

// Helper function to get tags display
function getTagsDisplay(subject, isPrivate = false) {
    let tags = [];
    
    if (isPrivate) {
        // For private search, use private_tags
        if (subject.private_tags && subject.private_tags.length > 0) {
            tags = subject.private_tags.map(tag => tag.tag_name);
        }
    } else {
        // For public search, use public tags
        if (subject.tags && subject.tags.length > 0) {
            tags = subject.tags.map(tag => tag.tag_name);
        }
    }
    
    if (!tags || tags.length === 0) return null;
    
    const tagText = tags.join(' ');
    
    return (
        <>
            <span className="tip_i">/</span>
            <span className="tip"> 标签: {tagText} </span>
        </>
    );
}

// Helper function to get comment display (only for private results)
function getCommentDisplay(subject, isPrivate = false) {
    if (!isPrivate) return null;
    
    if (subject.user_collection && subject.user_collection.length > 0) {
        let comment = subject.user_collection[0].comment;
        if (comment && comment.trim() !== '') {
            return (
                <div id="comment_box" className="comment-box">
                    <div className="item">
                        <div className="text_main_even">
                            <div className="text">{comment}</div>
                        </div>
                    </div>
                </div>
            );
        }
    }
    return null;
}

// Unified function that checks public/private and renders accordingly
export function getCollectInfo(subject, isPrivate = false) {
    return (
        <>
            <p className="collectInfo">
                {getRatingDisplay(subject, isPrivate)}
                {getDateDisplay(subject, isPrivate)}
                {getTagsDisplay(subject, isPrivate)}
            </p>
            {getCommentDisplay(subject, isPrivate)}
        </>
    );
}


export function getRateInfo(subject){
    let has_rating = subject.rating != null ? true: false
    let rating_round = (Math.round(subject.rating*10)/10).toFixed(1)
    let star_level = Math.round(subject.rating)
    let lt_10 = subject.votes < 10 ? true : false
    // console.log(`name: ${subject.name_cn}, has_rating: ${has_rating}, start level: ${star_level}, rating_round: ${rating_round}`)
    return (<p className="rateInfo">
             {!lt_10 && getStarLevelSpan(star_level)}
             {!lt_10 && <small className="fade"> {rating_round} </small>}
             {lt_10 ? <span className="tip_j">(少于10人评分)</span> :
                <span className="tip_j">{'('+subject.votes+'人评分)'}</span>}
         </p>
    )
}